import React from 'react';
import { Route } from 'react-router-dom';
import SlideRoutes from 'react-slide-routes';
import { useAppContext } from '@front-activerse/common-components';
import { IRoute } from '@front-activerse/common-components';

interface ICookbookPage {
  descendantRoutes: IRoute[];
}

const CookbookPage: React.FC<ICookbookPage> = ({ descendantRoutes }) => {
  const {
    consts: { SLIDE_ROUTES_DURATION },
  } = useAppContext();

  return (
    <SlideRoutes duration={+SLIDE_ROUTES_DURATION} animation="slide" destroy={false}>
      {descendantRoutes.map((route) => (
        <Route key={route.path} path={route.path} element={route.element} />
      ))}
    </SlideRoutes>
  );
};

export default CookbookPage;
